import React from 'react';
import { type BoxT } from '../box';
import { useRadioGroup } from './RadioGroupContext';
import { RadioGroupItem } from './RadioGroupItem';

export interface RadioGroupItemGenericProps<T extends string | number>
  extends BoxT {
  value: T;
  disabled?: boolean;
  children: React.ReactNode;
}

export const RadioGroupItemGeneric = React.forwardRef<
  HTMLDivElement,
  RadioGroupItemGenericProps<string | number>
>(({ value, disabled = false, ...boxProps }, ref) => {
  const { value: selectedValue, name, onChange } = useRadioGroup();

  const isSelectedItem = value === selectedValue;
  const handleChange = () => onChange(value);

  return (
    <RadioGroupItem
      value={value}
      checked={isSelectedItem}
      disabled={disabled}
      onChange={handleChange}
      name={name}
      ref={ref}
      {...boxProps}
    />
  );
});
